<div class="day" [style.font-size]="calendarDay.settings.dayFontSize">
  {{ calendarDay.date.getDate() }}
</div>

<div class="text" [style.font-size]="calendarDay.settings.textFontSize">
  {{ calendarDay.settings.text }}
</div>
